'use client';

import { Subsidiary } from '@coolblue-development/constants';
import { Flex } from '@coolblue-development/freddy';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { EnergyLabelContainer } from '@features/product/components/OrderBlock/EnergyLabel';
import type { EnergyLabelType, SubProducts } from '@features/product/typings';
import { useBreakpoints } from '@hooks/useBreakpoints';
import { ReactNode } from 'react';

type EnergyLabelRendererProps = {
  energyLabel: EnergyLabelType;
  subProducts: SubProducts[];
  availabilityState: ReactNode;
};

export const EnergyLabelRenderer = ({
  energyLabel,
  subProducts,
  availabilityState
}: EnergyLabelRendererProps) => {
  const hasEnergyLabel =
    energyLabel || subProducts?.some(subProduct => subProduct.product.energyLabel);
  const { subsidiary } = useRequestContext();
  const { isMobile } = useBreakpoints();
  const isGermany = subsidiary === Subsidiary.DE;

  if ((!isGermany || !hasEnergyLabel) && isMobile) {
    /* TODO: prevent availability state from blocking the whole page */
    return availabilityState;
  }

  return hasEnergyLabel ? (
    <Flex justifyContent={{ md: 'flex-end' }}>
      <EnergyLabelContainer
        energyLabel={energyLabel}
        subProducts={subProducts}
        flexDirection={isMobile ? 'column' : 'row'}
        direction={isMobile ? 'right' : 'left'}
        size={isMobile ? 'small' : 'medium'}
      />
    </Flex>
  ) : null;
};
